import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {PlayerGamesResponse} from './types';

// GET /players/<username>/games/ -- IsAuthenticated, open to any logged-in
// viewer (owner or visitor). `username` is required here (unlike the profile
// hook's `me/` fallback) -- the Games tab only ever mounts inside an already-
// loaded profile, whose payload always includes `username` even for the
// owner's own profile.
export const useGetPlayerGamesApi = (
  username?: string,
  page: number = 1,
  filters: {result?: string; time_class?: string; platform?: string} = {},
) =>
  useQuery(
    ['playerGames', username, page, filters],
    async (): Promise<PlayerGamesResponse> =>
      (
        await ChessRestClient.get(`/players/${username}/games/`, {
          params: {page, ...filters},
        })
      ).data,
    {enabled: !!username},
  );

export default useGetPlayerGamesApi;
